<template>
    <div class="position-box currencyTrading" :class="{theme: theme}">
      <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
          <div class="title">{{$t('langNew.jy')}}</div>
      </div>
      <ul class="head-tab-box">
        <li class="tab tab1 active">{{$t('jghy.yxhy')}}</li>
        <li class="tab tab3" @click="link">{{$t('jghy.jghy')}}</li>
      </ul>
        <div class="scroll-box">
            <div class="kline-head">
                <div class="kline-left">
                  <img class="btn-alert" v-if="!theme" @click="leftShow" src="@/assets/new/jiaoyigengduo.png" alt="" >
                  <img class="btn-alert" v-else @click="leftShow" src="@/assets/new/theme/jiaoyigengduo-white.png" alt="" >
                  <div>
                    <div class="t1" :data="currency">{{symbol}}</div>
                    <!-- <div class="t2">NAS100</div> -->
                  </div>
                </div>
                <div class="kline-right" v-if="!theme">
                    <img class="btn btn-collect" v-if="!isCollect" @click="collect" src="@/assets/Collect_gray.png"  alt="">
                    <img class="btn btn-collect" v-else @click="collect" src="@/assets/Collect_light.png" alt="">
                </div>
                <div class="kline-right" v-else>
                    <img class="btn btn-collect" v-if="!isCollect" src="@/assets/Collect_gray.png" alt="">
                    <img class="btn btn-collect" v-else src="@/assets/Collect_light.png" alt="">
                </div>
            </div>
            <div class="info-box">
                <div class="info-head">
                    <ul class="info-left">
                        <li class="price-box">
                          <div class="price"  :class="[ Number(updown) < 0 ?'red':'']">{{newprice | toFixed4}}</div>
                          <div class="p2">
                            <p class="text"><span :class="[ Number(updown) < 0 ?'red':'']">{{updown | toFixed2}}%</span></p>
                            <!-- <p class="text">2.0%</p> -->
                          </div>
                        </li>
                    </ul>
                    <ul class="open-box">
                      <li class="open-li">
                        <div class="t1">{{$t('langNew.kp')}}</div>
                        <div class="t2">{{open}}</div>
                        <div class="t1 text-right">{{$t('langNew.zg')}}</div>
                        <div class="t2 text-right">{{maxprice}}</div>
                      </li>
                      <li class="open-li">
                        <div class="t1">{{$t('langNew.zuoshou')}}</div>
                        <div class="t2">{{gp}}</div>
                        <div class="t1 text-right">&nbsp;{{$t('langNew.zd')}}</div>
                        <div class="t2 text-right">&nbsp;{{minprice}}</div>
                      </li>
                    </ul>
                </div>
                 <div class="info-foot">
                    <div class="item-box">
                      <div class="item time" :class="{active: tabIdx == -1}" @click="tab(-1,'1min')" data-val="1" data-type="1min" data-chartType="1"><span>{{$t('langNew.fs')}}</span></div>
                      <div class="item time" :class="{active: tabIdx == 0}" @click="tab(0,'1min')" data-val="1" data-type="1min" data-chartType="1">1<span>{{$t('kxt.fz')}}</span></div>
                      <div class="item time" :class="{active: tabIdx == 1}" @click="tab(1,'15min')" data-val="15" data-type="15min" data-chartType="1">15<span>{{$t('kxt.fz')}}</span></div>
                      <div class="item time" :class="{active: tabIdx == 2}" @click="tab(2,'60min')" data-val="60" data-type="60min" data-chartType="1">1<span>{{$t('kxt.xs')}}</span></div>

                      <div class="item time" :class="{active: tabIdx == 3}" @click="tab(3,'1day')" data-val="1D" data-type="1day" data-chartType="1">1<span>{{$t('kxt.tian')}}</span></div>
                      <div class="item more" :class="{moreActive: isMore}" @click="moreClick">
                          <div>{{$t('kxt.gd')}}</div>
                          <img class="down" src="@/assets/trend_more_gray.png" v-show="!isMore" alt="">
                          <img class="down" src="@/assets/trend_more_light.png" v-show="isMore" alt="">
                      </div>
                      <!-- 更多框 -->
                      <div class="alert-sdt-box" v-show="isMore">
                        <ul class="alert-sdt-ul">
                          <li class="alert-more-list">
                              <div class="text" :class="{active: timeIdx == 0}" data-val="5" data-type="5min" data-chartType="1" @click="timeClick(0,'5min')">5<span>{{$t('kxt.fz')}}</span></div>
                              <div class="text" :class="{active: timeIdx == 1}" data-val="30" data-type="30min" data-chartType="1" @click="timeClick(1,'30min')">30<span>{{$t('kxt.fz')}}</span></div>
                              <div class="text" :class="{active: timeIdx == 2}" data-val="1W" data-type="1week" data-chartType="1" @click="timeClick(2,'1week')">1<span>{{$t('kxt.zhou')}}</span></div>
                          </li>
                        </ul>
                      </div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <!-- k线图 -->
            <div id="charts" class="charts"></div>
            <div class="line"></div>
            <div class="cont-box">
              <div class="tab-wrap">
                <ul class="tab-box">
                    <li class="tab" :class="{active: footIdx == 0}" @click="footTab(0)">{{$t('hyjy.cc')}}</li>
                    <li class="tab" :class="{active: footIdx == 1}" @click="footTab(1)">{{$t('langNew.gd')}}</li>
                    <li class="tab" :class="{active: footIdx == 2}" @click="footTab(2)">{{$t('deals.pied')}}</li>
                    <li class="tab"><img class="icon" @click="more" src="@/assets/dingdan.png" alt=""></li>
                </ul>
              </div>
              <!-- 持仓 -->
              <ul class="item-box">
                <li class="item-li"  v-for="(item,index) in positionList" :key="index">
                  <div class="li-head">
                      <div v-if="footIdx == 0"><span class="title">{{item.currency}}</span><span class="bei" v-if="item.type == 1">{{$t('kxt.mr')}} {{item.position_a}}</span><span class="bei" v-if="item.type == 2">{{$t('kxt.mc')}} {{item.position_a}}</span></div>
                      <div v-else-if="footIdx == 2"><span class="title">{{item.currency}}</span><span class="bei" v-if="item.type == 4">{{$t('kxt.mr')}} {{item.lot_num}}</span><span class="bei" v-if="item.type == 3">{{$t('kxt.mc')}} {{item.lot_num}}</span></div>
                      <div v-else><span class="title">{{item.currency}}</span><span class="bei" v-if="item.mark == 1">{{$t('kxt.mr')}} {{item.amount}}</span><span class="bei" v-if="item.mark == 2">{{$t('kxt.mc')}} {{item.amount}}</span></div>
                      <div class="btn-pc" @click.stop="pingcang(item)" v-show="footIdx == 0">{{$t('hyjy.pc')}}</div>
                      <div class="btn-pc" @click.stop="cancelOrder(item.id)" v-show="footIdx == 1 && item.status == 0">{{$t('hyjy.cd')}}</div>
                    </div>
                    <ul class="ul-box">
                      <li class="li li-lt">
                        <div class="t2">
                          <div class="p1" v-if="footIdx != 1">
                            <div class="money">{{item.open_price}}</div>
                            <div class="text">{{$t('hyjy.kcjg')}}</div>
                          </div>
                          <div class="p1" v-else>
                            <div class="money">{{item.price}}</div>
                            <div class="text">{{$t('langNew.gdjg')}}</div>
                          </div>
                          <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                          <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                          <div class="p1" v-if="footIdx != 2">
                            <div class="money">{{newprice}}</div>
                            <div class="text">{{$t('langNew.dqjg')}}</div>
                          </div>
                          <div class="p1" v-if="footIdx == 2">
                            <div class="money">{{item.close_out_price}}</div>
                            <div class="text">{{$t('langNew.pcjg')}}</div>
                          </div>
                        </div>
                      </li>
                      <li class="li" v-show="footIdx != 1">
                        <div class="t1 price"><span v-show="item.profit_loss > 0">+</span>{{item.profit_loss | toFixed4}}</div>
                      </li>
                    </ul>
                </li>
                <!-- <li class="item-li">
                  <div class="li-head">
                      <div><span class="title">BTC</span><span class="bei">买涨 0.5</span></div>
                      <div class="btn-pc" @click="pingcang()">{{$t('hyjy.pc')}}</div>
                    </div>
                    <ul class="ul-box">
                      <li class="li li-lt">
                        <div class="t2">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">{{$t('hyjy.kcjg')}}</div>
                          </div>
                          <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                          <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">{{$t('langNew.dqjg')}}</div>
                          </div>
                        </div>
                      </li>
                      <li class="li">
                        <div class="t1 price" >+60.76</div>
                      </li>
                    </ul>
                </li> -->
              </ul>
              <!-- <ul class="item-box" v-show="footIdx == 0">
                <li class="item-li">
                  <div class="li-head">
                      <div><span class="title">BTC</span><span class="bei">买涨 0.5</span></div>
                      <div class="btn-pc" @click="pingcang()">{{$t('hyjy.pc')}}</div>
                    </div>
                    <ul class="ul-box">
                      <li class="li li-lt">
                        <div class="t2">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">开仓价格</div>
                          </div>
                          <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                          <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">当前价格</div>
                          </div>
                        </div>
                      </li>
                      <li class="li">
                        <div class="t1 price" >+60.76</div>
                      </li>
                    </ul>
                </li>
              </ul> -->
              <!-- 挂单 -->
              <!-- <ul class="item-box" v-show="footIdx == 1">
                <li class="item-li">
                  <div class="li-head">
                    <div><span class="title">BTC</span><span class="bei">买涨 0.5</span></div>
                    <div class="btn-pc" @click="cheXiao">{{$t('langNew.cx')}}</div>
                    </div>
                    <ul class="ul-box">
                      <li class="li li-lt">
                        <div class="t2">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">挂单价格</div>
                          </div>
                          <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                          <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">当前价格</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                </li>
              </ul> -->
              <!-- 已平仓 -->
              <!-- <ul class="item-box" v-show="footIdx == 2">
                <li class="item-li">
                  <div class="li-head li-head2"><span class="title">BTC</span><span class="bei">买涨 0.5</span></div>
                    <ul class="ul-box">
                      <li class="li li-lt">
                        <div class="t2">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">开仓价格</div>
                          </div>
                          <img class="icon" v-if="!theme" src="@/assets/new/jiantou_xiangyou.png" alt="">
                          <img class="icon" v-else src="@/assets/new/theme/jiantou_xiangyou_white.png" alt="">
                          <div class="p1">
                            <div class="money">20996.6</div>
                            <div class="text">平仓价格</div>
                          </div>
                        </div>
                      </li>
                      <li class="li">
                        <div class="t1 price"><span>+</span>20996.6</div>
                      </li>
                    </ul>
                </li>
              </ul> -->
              <!-- 暂无数据 -->
              <div class="null-box" v-show="isNoData">
                  <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                  <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                  <p class="text">{{$t('zwsj.title')}}</p>
              </div>
            </div>
        </div>
        <div class="mask" v-show="isMask" @click="cancle"></div>
         <!-- 平仓弹窗 -->
        <div class="alert-pc-box" v-show="isPc">
          <div class="title">
              {{$t('hyjy.pc')}}
              <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <div class="alert-item-box">
              <div><span class="title">{{pcCont.currency}}</span><span class="buy" v-if="pcCont.type == 1">{{$t('kxt.mr')}}</span><span class="buy" v-if="pcCont.type == 2">{{$t('kxt.mc')}}</span><span class="lot">{{pcCont.position_a}} {{$t('langNew.shou')}}</span></div>
              <ul class="ul-box">
                  <li class="li">
                    <div class="t1 price">USD<span v-show="pcCont.profit_loss > 0">+</span>{{pcCont.profit_loss | toFixed4}}</div>
                    <div class="t2">{{$t('langNew.fdjyk')}}</div>
                  </li>
                  <li class="li text-center">
                      <div class="t1">{{pcCont.open_price}}</div>
                      <div class="t2">{{$t('hyjy.kcjg')}}</div>
                  </li>
                  <li class="li text-right">
                      <div class="t1">{{pcCont.new_price}}</div>
                      <div class="t2">{{$t('langNew.dqjg')}}</div>
                  </li>
              </ul>
          </div>
          <div class="tips">{{$t('langNew.pcsl')}}</div>
          <div class="num-box">
              <img class="icon" src="@/assets/new/jian.png" @click="num(-1,pcCont.position_a)" alt="">
              <div>
                  <div class="t1"><input class="number" type="text" v-model="number" @keyup="keyMoney2"> <div>{{$t('langNew.shou')}}</div></div>
                  <div class="t2">{{$t('langNew.ksrfw')}} 0-{{pcCont.position_a}}</div>
              </div>
                  <img class="icon" src="@/assets/new/jia2.png" @click="num(1,pcCont.position_a)" alt="">
          </div>
          <div class="btn-sure btn-bg" @click="pcSure(pcCont)">{{$t('langNew.qrpc')}}</div>
        </div>
        <!-- 左侧弹框  -->
        <div class="alert-left" v-show="isLeftShow">
            <ul class="tab-box">
               <li class="tab" :class="{active: tabLeftIdx == 0}" @click="tabLeft(0,0)">{{$t('bbjy.zx')}}</li>
              <li class="tab" :class="{active: tabLeftIdx == 2}" @click="tabLeft(2,1)">{{$t('langNew.gjs')}}</li>
              <li class="tab" :class="{active: tabLeftIdx == 3}" @click="tabLeft(3,1)">{{$t('langNew.yy')}}</li>
            </ul>
            <ul class="ul-box">
                <li class="list" :class="{active: item.symbol == symbol}" v-for="(item,index) in leftData" :key="item.id" @click="leftClick(index,item.name,item.symbol,item.type)">
                    <div class="list-box">
                        <div class="t1">{{item.name}}/<span>USDT</span></div>
                        <div class="price" :class="{green: item.change > 0}">{{item.new_price | toFixed4}}</div>
                    </div>
                </li>
                <!-- <li class="list">
                    <div class="t1">BTC <span>/USDT</span></div>
                    <div class="price">5000</div>
                </li> -->
            </ul>
        </div>
        <div class="btn-box">
          <div class="btn btn-sell" @click="buyChange(2)">
            <div class="t1" v-show="newprice">{{parseFloat(newprice) | toFixed4}}</div>
            <div class="t2">{{$t('bbjy.mc')}}</div>
          </div>
          <div class="btn btn-buy" @click="buyChange(1)">
            <div class="t1" v-show="newprice">{{(parseFloat(newprice)) | toFixed4}}</div>
            <div class="t2">{{$t('bbjy.mr')}}</div>
          </div>
        </div>
        <loading v-show="isLoad"></loading>
    </div>
</template>

<script>
import loading from '@/components/loading.vue'
import echarts from 'echarts'
let that = this;
var socket = {};
var myChart;
socket.bh = true;
export default {
    name: 'preciousMetal',
    inject: ['reload'],
    data () {
        return {
          theme: false,
          isShow: false,
          isBuy: false,
          uid: '',
          token: '',
          tabIdx: -1,
          footIdx: 0,
          isLoad: false,
          isMore: false,
          isSdt: false,
          websock: null,
          leftData: [],
          curLeftData: [],
          isMask: false,
          isLeftShow: false,//左侧币种弹窗
          leftIdx: 0,
          tabLeftIdx: 2,//贵金属
          lists: [],
          newData: '',
          currency: '',
          symbol: '',
          currency_name: '',
          histime: '',
          curprice: '',
          newprice: '',
          updown: '',
          maxprice: '',
          minprice: '',
          open: '',
          gp: '',
          dayvom: '',
          deList: [],
          prevData: [],
          timeIdx: 3,
          xianjia: '',//现价
          useBalance: '',//可用余额
          timer: null,
          timerTimes: null,
          placeholder: '',
          klineTimer: null,
          klineTimer2: null,//5秒定时
          count: 1,
          currencyList: [],
          klineData: '',
          isPc: false,
          currency_type: '',
          main_type: '',
          currency_way: 1,//1买入，2卖出
          number: '',
          money: 1,
          stop_loss: '',//止损
          take_profit: '',//止盈
          time_type: 2,
          isCollect: 0,
          collectArr: [],
          currencyAll: '',
          isNoData: false,
          downTimer: null,
          websock2: null,
          ktype: "1min",
          positionList: [],
          wt: 13,//挂单
          type: 2,
          pcCont: {},
          page: 1,
          limit: 10,
          klineDates: [],
          klineDatas: [],
          yAxisData: [],
          volumes: [],
          current: -1,
          dynamicItems: [
            {
              name: "日K",
              type: "line",
              data: [],
              symbol: "none", //去除圆点
              smooth: true,
              lineStyle: { normal: { opacity: 1, width: 2, color: "#DCDCDC" } },
              z: 5,
              areaStyle: {
                origin: 'start',
                color:new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                      {offset: 0, color: '#ddd'},
                      {offset: 0.5, color: 'pink'},
                      {offset: 1, color: 'red'}
                  ]),
                opacity:0.5
              }
            },
          ],
          lockReconnect: false, //soket重连
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      if(this.$route.query.symbol){
        this.symbol = this.$route.query.symbol;
        this.currency = this.$route.query.symbol.split('/')[0];
      }
    },
    mounted() {
      let that = this;
      let params = {
          id: 1,
          type: 2
      }
      this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 1000){
            setTimeout(()=>{
              this.$router.push('/login');
            },1000)
            return false
          }
          if(that.symbol == '' || that.symbol == null){
            that.currency = resData[0].currency;
            that.symbol = resData[0].symbol;
            that.getmarketList();
            that.getCollect();//是否收藏
            that.initWebSocket();
            that.getKlineHistory();
            that.getPositionList();
        }else{
          that.getmarketList();
          that.getCollect();//是否收藏
          that.initWebSocket();
          that.getKlineHistory();
          that.getPositionList();
        }
      }).catch(function(err){
          console.log(err)
      })
      myChart = echarts.init(document.getElementById('charts'));
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      leftShow(){
        this.isLeftShow = true;
        this.isMask = true;
        this.tabLeftIdx = 2;
        this.leftData = [];
        this.getmarketList(2,1);
      },
      tabLeft(idx,id){
        this.tabLeftIdx = idx;
        this.getmarketList(idx,id);
      },
      tab(idx,ktype){
        this.klineDatas = [];
        this.tabIdx = idx;
        this.ktype = ktype;
        this.current = idx;
        if(myChart.clear) {
          myChart.clear();
        }
        if(this.current !== -1) {
          var upColor = "#00c483";
          var downColor = "#d14b65";
          this.dynamicItems = [
            {
              type: "candlestick",
              name: "日K",
              data: [],
              itemStyle: {
                color: upColor,
                color0: downColor,
                borderColor: upColor,
                borderColor0: downColor,
              },
              markPoint: {
                symbol: "rect",
                symbolSize: [-10, 0.5],
                symbolOffset: [5, 0],
                itemStyle: {
                  color: "rgba(255,255,255,.87)",
                },
                label: {
                  // show: false,
                  color: "rgba(255,255,255,.87)",
                  offset: [10, 0],
                  fontSize: 10,
                  align: "left",
                  formatter: function (params) {
                    return Number(params.value).toFixed(2);
                  },
                },
                data: [
                  {
                    name: "max",
                    type: "max",
                    valueDim: "highest",
                  },
                  {
                    name: "min",
                    type: "min",
                    valueDim: "lowest",
                  },
                ],
              },
            },
          ];
        } else {
          this.dynamicItems = [
            {
              name: "日K",
              type: "line",
              data: [],
              symbol: "none", //去除圆点
              smooth: true,
              lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
              z: 5,
              areaStyle: {
                origin: 'start',
                color:new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                      {offset: 0, color: '#ddd'},
                      {offset: 0.5, color: 'pink'},
                      {offset: 1, color: 'red'}
                  ]),
                opacity:0.5
              }
            },
          ];
        }
        this.draw();
        this.websock.onopen();
        this.getKlineHistory();
        this.getKline();
      },
      timeClick(idx,ktype){
        this.timeIdx = idx;
        this.isMore = false;
        this.tabIdx = 5;
        this.ktype = ktype;
        this.current = idx;
        this.klineDatas = [];
        if(myChart.clear) {
          myChart.clear();
        }
        if(this.current !== -1) {
          var upColor = "#00c483";
          var downColor = "#d14b65";
          this.dynamicItems = [
            {
              type: "candlestick",
              name: "日K",
              data: [],
              itemStyle: {
                color: upColor,
                color0: downColor,
                borderColor: upColor,
                borderColor0: downColor,
              },
              markPoint: {
                symbol: "rect",
                symbolSize: [-10, 0.5],
                symbolOffset: [5, 0],
                itemStyle: {
                  color: "rgba(255,255,255,.87)",
                },
                label: {
                  // show: false,
                  color: "rgba(255,255,255,.87)",
                  offset: [10, 0],
                  fontSize: 10,
                  align: "left",
                  formatter: function (params) {
                    return Number(params.value).toFixed(2);
                  },
                },
                data: [
                  {
                    name: "max",
                    type: "max",
                    valueDim: "highest",
                  },
                  {
                    name: "min",
                    type: "min",
                    valueDim: "lowest",
                  },
                ],
              },
            },
          ];
        } else {
          this.dynamicItems = [
            {
              name: "日K",
              type: "line",
              data: [],
              symbol: "none", //去除圆点
              smooth: true,
              lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
              z: 5,
              areaStyle: {
                origin: 'start',
                color:new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                      {offset: 0, color: '#ddd'},
                      {offset: 0.5, color: 'pink'},
                      {offset: 1, color: 'red'}
                  ]),
                opacity:0.5
              }
            },
          ];
        }
        this.draw();
        this.websock.onopen();
        this.getKlineHistory();
        this.getKline();
      },
      leftClick(idx,name,symbol,type){//左侧币种选择
        this.tabIdx = -1;
        this.leftIdx = idx;
        this.currency = name;
        this.symbol = symbol;
        this.isLeftShow = false;
        this.isMask = false;
        this.page = 1;
        this.positionList = [];
        this.klineDatas = [];
        this.current = -1;
        if(myChart.clear) {
          myChart.clear();
        }
        if(this.current !== -1) {
          var upColor = "#00c483";
          var downColor = "#d14b65";
          this.dynamicItems = [
            {
              type: "candlestick",
              name: "日K",
              data: [],
              itemStyle: {
                color: upColor,
                color0: downColor,
                borderColor: upColor,
                borderColor0: downColor,
              },
              markPoint: {
                symbol: "rect",
                symbolSize: [-10, 0.5],
                symbolOffset: [5, 0],
                itemStyle: {
                  color: "rgba(255,255,255,.87)",
                },
                label: {
                  // show: false,
                  color: "rgba(255,255,255,.87)",
                  offset: [10, 0],
                  fontSize: 10,
                  align: "left",
                  formatter: function (params) {
                    return Number(params.value).toFixed(2);
                  },
                },
                data: [
                  {
                    name: "max",
                    type: "max",
                    valueDim: "highest",
                  },
                  {
                    name: "min",
                    type: "min",
                    valueDim: "lowest",
                  },
                ],
              },
            },
          ];
        } else {
          this.dynamicItems = [
            {
              name: "日K",
              type: "line",
              data: [],
              symbol: "none", //去除圆点
              smooth: true,
              lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
              z: 5,
              areaStyle: {
                origin: 'start',
                color:new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                      {offset: 0, color: '#ddd'},
                      {offset: 0.5, color: 'pink'},
                      {offset: 1, color: 'red'}
                  ]),
                opacity:0.5
              }
            },
          ];
        }
        this.draw();
        this.websock.onopen();
        this.getKlineHistory();
        this.getKline();
        this.getPositionList();
        if(type == 1){
          this.$router.push({ path: '/contractTransaction', query: { symbol: symbol } })
        }
      },
      initWebSocket(){ //初始化weosocket
        const wsuri = this.socket_url;
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
        this.klineTimer = setInterval(()=>{
          var msg = {"action": "kline",'currency':this.currency,"content": ''};
          this.websocketsend(JSON.stringify(msg));
        },3000)
      },
      websocketonerror(){//连接建立失败重连
        this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
          let currency = this.currency;
          if(JSON.parse(e.data).action == "marketprice"){
              let msg = JSON.parse(e.data).content;
              let daymarket = msg[currency];
              this.newprice = daymarket.now_price;
              this.maxprice = daymarket.high;
              this.minprice = daymarket.low;
              this.open = daymarket.open;
              this.gp = daymarket.close;
              this.dayvom = Number(daymarket.volume).toFixed(4);
              this.updown = daymarket.change;
              let keyArr = [];
              for(var x in this.currencyList){
                  for(var y in this.leftData){
                    if(!msg[x]) return;
                    if(msg[x].currency_name == this.leftData[y].currency_name){
                        this.leftData[y]['new_price'] = msg[x].now_price;
                        this.leftData[y]['change'] = msg[x].change;
                        keyArr.push(this.leftData[y]);
                        break;
                    }
                  }
              }
              this.leftData = keyArr;
          }else if(JSON.parse(e.data).action == "kline"){
              var ktype = this.ktype;
              this.klineData = '';
              let msg = JSON.parse(e.data).content;
              var klineDatas = msg.kline;
              this.klineData = klineDatas[ktype]
              this.prevData.push(JSON.parse(JSON.stringify(this.klineData)));
              if(this.klineData) return true;
              if(this.klineData.Date > this.prevData[0].Date){
                this.prevData.push(JSON.parse(JSON.stringify(this.klineData)))
                if(this.prevData.length>1)this.prevData.shift();
                this.klineDates.push(this.times(this.klineData.Date))
                this.klineDatas.push([this.klineData.Open,this.newprice,this.klineData.Low,this.klineData.High,this.klineData.Volume]);
                this.yAxisData.push(this.klineData.High);
                this.getKline();
              }
              if(this.prevData.length>1)this.prevData.shift();
          }
      },
      websocketsend(Data){//数据发送
        this.websock.send(Data);
      },
      websocketclose(e){  //关闭
          // console.log('断开连接',e);
      },
      getCollect(){
          let that = this;
          let params = {
            id: 1,
            symbol:that.symbol
          }
          this.$ajax.get('/web/getmarketList',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                setTimeout(()=>{
                  this.$router.push('/login');
                },1000)
                return false
              }
              that.isCollect = resData[0].is_collect;
          }).catch(function(err){
              console.log(err)
          })
        },
        collect(){//收藏
          let that = this;
          that.leftData.find((item) => {
            if(item.symbol == that.symbol){
              var id = item.id;
              let params = {
                id: id
              }
              this.$ajax.post('/web/addCollectCurrenct',params).then((res) => {
                let resData = res.data;
                that.isCollect = !that.isCollect
              }).catch(function(err){
                  console.log(err)
              })
            }
          })
        },
        getCurPrice(){
          let that = this;
          let params = {
              id: 1,
              symbol: that.symbol,
          }
          this.$ajax.get('/web/getmarketList',{params}).then((res) => {
              let resData = res.data.data;
              that.xianjia =  resData[0].new_price;
          }).catch(function(err){
              console.log(err)
          })
        },
        getmarketList(type,id){
          let that = this;
          var types = type == 0 ? 2 : type
          let params = {
            type: types,
            id: id,
          }
          that.isLoad = true;
          this.$ajax.get('/web/getmarketList',{params}).then((res) => {
              let resData = res.data.data;
              that.leftData = resData;
              that.currencyList = [];
              for (var curr in resData){
                  that.currencyList[that.leftData[curr].currency_name.toLowerCase()] = [that.leftData[curr].icon,that.leftData[curr].symbol] ;
              }
              that.isLoad = false;
          }).catch(function(err){
              console.log(err)
          })
      },
      link(id){
        this.$router.push({ path: '/contractTransaction2', query: {symbol: this.symbol} })
      },
      more(){
        this.$router.push('/contractOrder')
      },
      close(){
        this.isShow = false;
        this.isMask = false;
        this.isPc = false;
        this.isBuy = false;
        this.count = 1;
      },
      cancle(){
        this.isLeftShow = false;
        this.isMask = false
      },
      moreClick(){
        this.isMore = !this.isMore;
        this.isSdt = false;
      },
      pingcang(item){//平仓弹窗
        this.isMask = this.isPc = true;
        this.pcCont = item;
        this.number = item.position_a;
      },
      pcSure(item){//确认平仓
        let that = this;
        // var type = item.type == 1 ? 4 : 3
        let params = {
          id: item.id
          // amount: that.number,
          // mark: type,
          // currency: item.currency,
        }
        this.$ajax.post('/web/closePosition',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                that.$toast.center(resData.message);
                that.isPc = false;
                that.isMask = false;
                that.page = 1;
                that.positionList = [];
                that.getPositionList();
            }else{
                this.$toast.center(resData.message);
                return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      cancelOrder(id){//撤单
        var that = this;
        let params = {
          id: id
        }
        this.$ajax.post('/web/orderCancel',params).then((res) => {
          let resData = res.data;
          that.$toast.center(resData.message);
          that.page = 1;
          that.positionList = [];
          that.getPositionList();
        }).catch(function(err){
            console.log(err)
        })
      },
      getPositionList(){//持仓记录
        let that = this;
        if(this.footIdx != 1){
          var params = {
            currency: that.currency,
            is_pl_r: 1,
            page: that.page
          }
          var url = this.footIdx == 0 ? '/web/getPositionList' : '/web/getClosePositionList'
        }else{
          var params = {
            currency: that.currency,
            type: that.type,
            wt: that.wt,
            limit: that.limit,
            page: that.page
          }
          var url = 'web/getWeiTuo'
        }
        this.$ajax.get(url,{params}).then((res) => {
            let resData = res.data.data;
            if(resData.list.length > 0){
              that.positionList = that.positionList.concat(resData.list);
              that.curDataLength = resData.list.length;
            }else{
              that.curDataLength = resData.list.length;
            }
            if(that.positionList.length > 0){
                that.isNoData = false;
            }else{
                that.isNoData = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      buyChange(id){
        this.$router.push({ path: '/trading', query: { symbol: this.symbol,type: id } })
      },
      num(id,max){
        if(id < 0){
          if(parseFloat(this.number) > 1){
            this.number = (parseFloat(this.number) -1).toFixed(4)
          }
        }else{
          if(parseFloat(this.number) < parseFloat(max)){
          this.number = (parseFloat(this.number) +1).toFixed(4);
          }else{
            this.number = parseFloat(max).toFixed(4)
          }
        }
      },
      footTab(idx){
        this.footIdx = idx;
        this.page = 1;
        this.positionList = [];
        this.getPositionList();
      },
      getColor(){
        var upColor = '#00c483';
        var downColor = '#d14b65';
        var params = this.yAxisData;
        if (params.dataIndex == 0) {
          return upColor
        } else {
          // 这里注意实际项目中，浮点型数据的运算，单纯的比较大小会出现异常现象
          if (params.data[1] > this.yAxisData[params.dataIndex - 1][1]) return upColor;
          return downColor
        }
       },

      times(timess){
        var date = new Date((timess));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + " " + h + m + s;
        // return h + m + s;
      },
      getKlineHistory(){
        var that = this;
        var symbol = this.symbol.replace('/', '').toLowerCase();
        let params = {
          symbol: symbol,
          period: that.ktype,
        }
        this.$ajax.get('/web/new_timeshar',{params}).then((res) => {
          if(res.status == 200){
            if(res.data.data.length>0){
              let resData = res.data.data;
              var newArr2 = [];
              var klineHistory = resData;
              klineHistory.forEach((item,i)=>{
                if(String(item.Date).length == 10){
                  item.Date = Number(item.Date * 1000);
                }else{
                  item.Date = Number(item.Date);
                }
                item.volume = Number(item.Volume);
                item.open = Number(item.Open);
                item.close = Number(item.Close);
                item.high = Number(item.High);
                item.low = Number(item.Low);
                newArr2.push([that.times(item.Date),item.Open,item.Close,item.Low,item.High,item.Volume]);
              });
              newArr2.reverse();
              that.newArr = newArr2;
              that.klineDates = newArr2.map(function(item){
                return item[0];
              })
              that.klineDatas = newArr2.map(function(item) {
                return [+item[1], +item[2], +item[3], +item[4], +item[5]];
              });
              that.volumes = newArr2.map(function(item, index) {
                return [index, item[5], item[1] > item[2] ? 1 : -1];
              });
              that.yAxisData = newArr2.map(function(item, index) {
                return item[2];
              });
              that.draw();
              that.getKline();
            }
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      // 获取k线数据,生成k线
      getKline(data){
        if(data){
          data = data
        }else{
          data = this.klineDatas;
        }
        var dataNow = this.calculateMA(1,data);
        var dataMA5 = this.calculateMA(5, data);
        var dataMA10 = this.calculateMA(10, data);
        var dataMA30 = this.calculateMA(30, data);
        var volumeMA5 = this.calculateMA(5, this.volumes);
        var volumeMA10 = this.calculateMA(10, this.volumes);
        var option = {
          grid: [
            {
              right: 60,
            },
            {
              right: 60,
            },
          ],
          xAxis: [
            {
              data: this.klineDates
            },
            {
              data: this.klineDates
            },
          ],
          series: [
            {
              name: '日K',
              data: this.current=== -1 ? dataNow : data,
            },
            {
              name: 'MA5',
              data: dataMA5
            },
            {
              name: 'MA10',
              data: dataMA10
            },
            {
              name: 'MA30',
              data: dataMA30
            },
            {
              name: 'Volume',
              data: this.volumes
            },
            {
              name: 'VolumeMA5',
              data: volumeMA5
            },
            {
              name: 'VolumeMA10',
              data: volumeMA10
            },
          ]
        }
        option && myChart.setOption(option);
      },
      getTime(times,type) {
        let time = times[0];
        let timeLength = String(time).length;
        let timeStr = null;
        if (timeLength === 10) {
          timeStr = new Date(time * 1000);
        } else if (timeLength === 13) {
          timeStr = new Date(time * 1);
        } else if (timeLength === 19) {
          timeStr = new Date(time);
        }
        let year = timeStr.getFullYear();
        let month = timeStr.getMonth() + 1;
        let day = timeStr.getDate();
        let hour = timeStr.getHours();
        let minute = timeStr.getMinutes();
        let second = timeStr.getSeconds();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        if (second < 10) {
          second = "0" + second;
        }
        if (type === 1) {
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
          // return `${hour}:${minute}:${second}`;
        } else if (type === 2) {
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
        return `${year}-${month}-${day}`;
      },
      // 列表条数不足补全
      addItem(list,type){
        // type: 1开头加，2末尾加
        list=list || [];
        let len=20-list.length;
        if(len>0){
          for(let i=0;i<len;i++){
            if(type==1){
              list.unshift({})
            }else{
              list.push({})
            }
          }
        }
        return list;
      },
      formatterNum(value, precision) {
        // console.log(value)
        let reg = new RegExp('^\\d+(?:\\.\\d{0,' + precision + '})?')
        return value.toString().match(reg)
      },
      // 计算MA
      calculateMA(dayCount, data) {
        var result = [];
        for (var i = 0, len = data.length; i < len; i++) {
          if (i < dayCount) {
            result.push('-');
            continue;
          }
          var sum = 0;
          for (var j = 0; j < dayCount; j++) {
            sum += data[i - j][1];
          }
          // console.log(sum, dayCount)
          result.push((sum / dayCount).toFixed(6));
        }
        return result;
      },
      // 绘制(配置项)
      draw() {
      let that = this;
      var upColor = "#00c483";
      var downColor = "#d14b65";
      var colorList = [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ];
      var labelFont = "bold 12px Sans-serif";
      var bgColor = this.theme ? '#131e30' : '#fff'
      var option = {
        backgroundColor: bgColor,
        title: {
          show: false,
        },
        legend: {
          show: false,
        },
        visualMap: {
          show: false,
          seriesIndex: 4,
          dimension: 2,
          pieces: [
            {
              value: 1,
              color: downColor,
            },
            {
              value: -1,
              color: upColor,
            },
          ],
        },
        grid: [
          {
            top: "5%",
            left: 20,
            right: 20,
            height: "70%",
          },
          {
            top: "80%",
            left: 20,
            right: 20,
            height: "16%",
          },
        ],
        axisPointer: {
          //坐标轴指示器配置项
          link: {
            xAxisIndex: "all",
          },
          type:'cross',
          label: {
            backgroundColor: "#0d1723",
            color: "#fff",
            borderColor: "rgb(99, 117, 139)",
            borderWidth: 1,
            borderRadius: 2,
            fontSize: 10,
          },
        },
        xAxis: [
          {
            type: "category", //坐标轴类型。(value:数值轴，适用于连续数据。,category:类目轴，适用于离散的类目数据,time: 时间轴，适用于连续的时序数据,log:对数轴。适用于对数数据)
            data: [], //类目数据，在类目轴（type: 'category'）中有效。
            scale: true,
            boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。
            axisLine: {
              show: false,
            }, //坐标轴轴线相关设置
            axisTick: {
              show: false,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              show: false,
            }, //坐标轴刻度标签的相关设置。
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
            min: "dataMin", //坐标轴刻度最小值。可以设置成特殊值 'dataMin'，此时取数据在该轴上的最小值作为最小刻度。
            max: "dataMax", //坐标轴刻度最大值。可以设置成特殊值 'dataMax'，此时取数据在该轴上的最大值作为最大刻度。
            axisPointer: {
              // label: {
              //   margin: 100,
              // },
              snap:true
            },
          },
          {
            type: "category",
            gridIndex: 1, //x 轴所在的 grid 的索引，默认位于第一个 grid。
            data: [], //类目数据，在类目轴（type: 'category'）中有效。
            scale: true,
            boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255,1)",
                width: 1,
              },
            }, //坐标轴轴线相关设置
            axisTick: {
              show: false,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              show: true,
              margin: 6,
              fontSize: 10,
              color: "rgba(99, 117, 139, 1.0)",
              formatter: function (value) {
                if (that.current !== 7 && that.current !== 8) {
                  return value;
                }
                return echarts.format.formatTime("MM-dd", value);
              },
            },
            splitNumber: 20,
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
            min: "dataMin", //坐标轴刻度最小值。可以设置成特殊值 'dataMin'，此时取数据在该轴上的最小值作为最小刻度。
            max: "dataMax", //坐标轴刻度最大值。可以设置成特殊值 'dataMax'，此时取数据在该轴上的最大值作为最大刻度。
            // axisPointer: { show: true, type: 'none', label: { show: false }},
          },
        ],
        yAxis: [
          {
            type: "value", //坐标轴类型。(value:数值轴，适用于连续数据。,category:类目轴，适用于离散的类目数据,time: 时间轴，适用于连续的时序数据,log:对数轴。适用于对数数据)
            position: "right", //y 轴的位置。'left','right'
            scale: true, //是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度。在双数值轴的散点图中比较有用。(在设置 min 和 max 之后该配置项无效。)
            axisLine: {
              show: true,
            }, //坐标轴轴线相关设置。
            offset: 50,
            axisTick: {
              show: true,
              inside: true,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              show: true,
              color: "rgba(99, 117, 139, 1.0)",
              inside: true,
              fontSize: 10,
              formatter: function (value) {
                return Number(value).toFixed(4);
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
          },
          {
            type: "value",
            position: "right",
            scale: true,
            gridIndex: 1,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],

        animation: true, //是否开启动画。
        color: colorList,
        tooltip: {
          // show: this.current!==1, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: "axis", //触发类型。item,axis,none
          formatter(params) {
            let tooltip = "";
            let time = "",
              open = 0,
              high = 0,
              low = 0,
              close = 0,
              amount = 0;
            for (var i = 0; i < params.length; i++) {
              if (params[i].seriesName === "日K") {
                time = params[i].name;parseInt
                let oneItem= {}
                if(that.current=== -1){
                  oneItem = that.newArr.find(e=>that.getTime(e, 1)===params[i].axisValue);
                }
                open =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current===-1?oneItem[1]:params[i].data[1], 5))
                    : 0;
                close =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current===-1?oneItem[2]:params[i].data[2], 5))
                    : 0;
                low =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current===-1?oneItem[3]:params[i].data[3], 5))
                    : 0;
                high =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current===-1?oneItem[4]:params[i].data[4], 5))
                    : 0;
                amount =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current===-1?oneItem[5]:params[i].data[5], 5))
                    : 0;
                // console.log(time,open,close,low,high,amount)
                tooltip =
                  '<div class="charts-tooltip">' +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Time" +
                  '</div><div class="ctr-value">' +
                  time +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Open" +
                  '</div><div class="ctr-value">' +
                  open +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "High" +
                  '</div><div class="ctr-value">' +
                  high +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Low" +
                  '</div><div class="ctr-value">' +
                  low +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Close" +
                  '</div><div class="ctr-value">' +
                  close +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Vol" +
                  '</div><div class="ctr-value">' +
                  amount +
                  "</div></div></div>";
              }
              if (params[i].seriesName === "MA5") {
                that.MA5 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "MA10") {
                that.MA10 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "MA30") {
                that.MA30 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "VolumeMA5") {
                that.volMA5 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 2))
                    : 0;
              }
              if (params[i].seriesName === "VolumeMA10") {
                that.volMA10 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 2))
                    : 0;
              }
            }
            return tooltip;
          },
          triggerOn: "click", //提示框触发的条件 'mousemove','click','mousemove|click','none'
          textStyle: {
            fontSize: 10,
          }, //提示框浮层的文本样式
          backgroundColor: "rgba(30,42,66,0.8);", //提示框浮层的背景颜色。
          borderColor: "#2f3a56", //提示框浮层的边框颜色。
          borderWidth: 2,
          position: function (pos, params, el, elRect, size) {
            //提示框浮层的位置，默认不设置时位置会跟随鼠标的位置。
            var obj = {
              top: 20,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 10;
            return obj;
          },
          axisPointer: {
            //坐标轴指示器配置项。
            label: {
              color: "rgba(255,255,255,.87)",
              fontSize: 9,
              backgroundColor: "#020204",
              borderColor: "#9c9fa4",
              shadowBlur: 0,
              borderWidth: 0.5,
              padding: [4, 2, 3, 2],
            },
            animation: false,
            type: "cross",
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(30, 42, 66, 0.1)", // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: "rgba(30, 42, 66,0.9)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(30, 42, 66,0.2)", // 100% 处的颜色
                  },
                ],
              },
              width: 1,
              shadowColor: "rgba(30, 42, 66,0.7)",
              shadowBlur: 0,
              shadowOffsetY: 68,
            },
          },
        },

        dataZoom: [
          {
            //用于区域缩放
            type: "inside",
            xAxisIndex: [0, 1],
            realtime: false,
            start: 50,
            end: 100,
          },
        ],
        series: [
          ...this.dynamicItems,
          {
            name: "MA5",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#eef4ba" } },
            z: 5,
            tooltip:{
              show:false
            }
          },
          {
            name: "MA10",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#83c1c5" } },
            z: 4,
            tooltip:{
              show:false
            }
          },
          {
            name: "MA30",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#b39cd8" } },
            z: 3,
            tooltip:{
              show:false
            }
          },
          {
            name: "Volume",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            tooltip:{
              show:false
            }
          },
          {
            name: "VolumeMA5",
            type: "line",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#eef4ba" } },
            z: 5,
            tooltip:{
              show:false
            }
          },
          {
            name: "VolumeMA10",
            type: "line",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#83c1c5" } },
            z: 4,
            tooltip:{
              show:false
            }
          },
        ],
      };
        myChart.setOption(option);
        // 加载上一页数据
        myChart.on('datazoom',function(params){
          let num=params.batch[0]['start'];
          if(num==0){
            console.log('到最左边了')
          }
        })
        window.addEventListener('resize', () => { myChart.resize()})
      },
      keyMoney(){
        // this.tzmoney = this.tzmoney.replace(/^(0+)|[^\d]+/g,'');
        this.tzmoney = this.tzmoney.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.tzmoney = this.tzmoney.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.tzmoney = this.tzmoney.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.tzmoney = this.tzmoney.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.tzmoney.indexOf(".") < 0 && this.tzmoney != "") { //首位是0的话去掉
            this.tzmoney = parseFloat(this.tzmoney);
        }
      },
      keyMoney2(){
        this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
            this.number = parseFloat(this.number);
        }
      },
    },
    sockets: {},
    filters:{
        fx(val){
            if(val == 1){
                return 'buy'
            }else if(val == 2){
                return 'sell'
            }else{
                return 'buy'
            }
        },
        toFixed2: function (value) {
            if(!value) return;
            value = Number(value);
            return value.toFixed(2);
        }
    },
    components:{
        loading,
    },
    computed: {

    },
    watch: {
      newprice: {
          handler:function (val,oldValue){
            var dataNow,option2;
            if(parseFloat(val) > 0){
              if(this.klineDatas.length > 0){
                dataNow = this.calculateMA(1,this.klineDatas);
                this.klineDatas[this.klineDatas.length-1][1] = val;
              };
              if(this.currency != $('.kline-head .kline-left .t1').attr('data')) return false;
              option2 = {
                series: [
                  {
                    name: '日K',
                    data: this.current===-1?dataNow: this.klineDatas,
                  },
                  {
                    markLine: {//图表标线
                      label: {
                        position: 'middle'
                      },
                      formatter: val.toString(),
                      data: [
                        {yAxis : val.toString()}
                      ]
                    },
                  }
                ]
              }
              option2 && myChart.setOption(option2);
            }
          },
          deep: true,
          immediate: true
      },
    },
    beforeDestroy(){

    },
    destroyed() {

    }
}
</script>
<style scoped>
    .head{
      position: fixed;
      top: 0;
      width: 100%;
      height: 1.6rem;
      padding: 0 .44rem;
      color: #000;
      line-height: 1.6rem;
      background: #fff;
      box-sizing: border-box;
      text-align: center;
    }
    .head .back{
      position: absolute;
      left: .4rem;
      top: 50%;
      width: .5rem;
      transform: translateY(-50%);
    }
    .head .title{
      font-size: .56rem;
    }
    .head-tab-box{
        position: fixed;
        top: 1.6rem;
        width: 100%;
        padding: .24rem 0 .5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }
    .head-tab-box .tab{
        /* width: 86px; */
        padding: 0 .46rem;
        height: .75rem;
        color: #000;
        font-size: .42rem;
        line-height: .75rem;
        border: 1px solid #b1b1b1;
        background: #efefef;
        text-align: center;
    }
    .head-tab-box .tab.active{
        color: #fff;
        background: #218adc;
    }
    .head-tab-box .tab1{
        border-radius: .6rem 0 0 .6rem;
    }
    .head-tab-box .tab2{
      border-left: 0;
      border-right: 0;
    }
    .head-tab-box .tab3{
        border-radius: 0 .6rem .6rem 0;
    }
    .scroll-box{
        position: absolute;
        left: -1px;
        right: 0;
        top: 4.22rem;
        bottom: 0;
        overflow-y: scroll;
    }
    .kline-head{
        position: fixed;
        top: 2.8rem;
        display: flex;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        padding: 0 .42rem;
        color: #fff;
        font-size: .48rem;
        background: #fff;
        box-sizing: border-box;
    }
    .kline-head .kline-left{
        display: flex;
        flex: 1;
        align-items: center;
    }
    .kline-head .kline-left .t1{
      color: #000;
      font-size: .48rem;
    }
    .kline-head .kline-left .t2{
      color: #757575;
      font-size: .34rem;
    }
    .kline-head .btn-back{
        width: .36rem;
        height: .6rem;
    }
    .kline-head .btn-alert{
        margin: 0 .38rem 0 0;
        width: .6rem;
        height: .6rem;
    }
    .kline-head .kline-right{
        display: flex;
        align-items: center;
    }
    .kline-head .kline-right .btn{
        width: .54rem;
        height: .54rem;
        margin-left: .3rem;
    }
    .kline-head .kline-right .btn-qp{
        margin-left: .54rem;
    }
    .info-box{
        position: relative;
        padding: .6rem .42rem;
        background: #fff;
    }
    .info-box .info-head{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .info-box .info-head .info-left .price-box{
      text-align: center;
    }
    .info-box .info-head .info-left .price{
      color: #27895b;
      font-size: .65rem;
    }
    .info-box .info-head .info-left .p2{
      display: flex;
      align-items: center;
    }
    .info-box .info-head .info-left .text{
      margin-left: .3rem;
      color: #27895b;
      font-size: .34rem;
    }
    .info-box .info-head .info-left .time{
        margin-top: .3rem;
        color: #757575;
        font-size: .32rem;
    }
    .info-box .info-head .info-right .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
        color: #7286a7;
        font-size: .36rem;
    }
    .info-box .info-head .info-right .num{
        margin-left: .3rem;
        color: #0f0f0f;
        font-size: .34rem;
    }
    .open-box{
      flex: 1;
      margin-left: .3rem;
    }
    .open-box .open-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .open-box .open-li:last-child{
      margin-top: .32rem;
    }
    .open-box .open-li .t1{
      width: 25%;
      color: #757575;
      font-size: .3rem;
    }
    .open-box .open-li .t2{
      width: 25%;
      color: #000;
      font-size: .3rem;
    }
    .info-box .info-foot{
        position: absolute;
        width: 90%;
    }
    .info-box .item-box{
        position: relative;
        z-index: 97;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .96rem 0 .3rem;
        color: #7286a7;
        font-size: .36rem;
    }
    .info-box .item-box .item .icon{
        width: .75rem;
        height: .75rem;
    }
    .info-box .item-box .item.more{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-box .item-box .item .down{
        width: .3rem;
        height: .3rem;
    }
    .info-box .item-box .item{
        position: relative;
    }
    .info-box .item-box .item.active{
        color: #218adc;
    }
    .info-box .item-box .item.moreActive{
        color: #218adc;
    }
    .info-box .item-box .item.active::after{
        position: absolute;
        left: 0;
        bottom: -.18rem;
        content: '';
        width: 100%;
        height: 2px;
        border-radius: .3rem;
        background: #218adc;
    }
    .info-box .alert-sdt-box{
        position: absolute;
        left: .18rem;
        right: .18rem;
        top: 1.6rem;
        width: 100%;
        padding: .42rem .48rem .42rem .36rem;
        border: 1px solid #4f4f4f;
        border-radius: .12rem;
        box-sizing: border-box;
        background: #131e30;
    }
    .info-box .alert-sdt-box .alert-sdt-list{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-box .alert-sdt-box .alert-sdt-list:last-child{
        margin-top: .42rem;
    }
    .info-box .alert-sdt-box .alert-sdt-list .text{
        padding-right: .42rem;
        color: #fff;
    }
    .info-box .alert-sdt-box .alert-sdt-info{
        display: flex;
        flex: 1;
        align-items: center;
        padding: 0 .3rem;
        border-left: 1px solid #526270;
    }
    .info-box .alert-sdt-box .alert-sdt-info .info-text{
        width: 1.35rem;
    }
    .info-box .alert-sdt-box .alert-sdt-info .active{
        color: #fff;
    }
    .info-box .alert-sdt-box .alert-sdt-list .icon{
        width: .66rem;
        height: .48rem;
    }
    .info-box .alert-sdt-box .alert-more-list{
        display: flex;
        align-items: center;
    }
    .info-box .alert-sdt-box .alert-more-list .text{
        flex: 1;
        border-right: 1px solid #7286a7;
        text-align: center;
    }
    .info-box .alert-sdt-box .alert-more-list .text:last-child{
        border-right: none;
    }
    .info-box .alert-sdt-box .alert-more-list .active{
        color: #fff;
    }
    .cont-box{
        padding: 0 0 2.8rem;
        background: #f3f4f6;
    }
    .cont-box.isBs{
      padding: 0;
    }
    .cont-box .tab-wrap{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 .4rem;
      background: #fff;
    }
    .cont-box .tab-box{
      position: relative;
      display: flex;
      width: 70%;
      align-items: center;
      flex: 1;
      padding: .5rem 0 .3rem;
      color: #878789;
      font-size: .5rem;
      overflow-x: scroll;
    }
    .cont-box .tab-box .tab{
        position: relative;
        margin-right: .6rem;
        font-size: .44rem;
        white-space: nowrap;
    }
    .cont-box .tab-box .tab.active{
        color: #4458ed;
        font-size: .52rem;
    }
    .cont-box .tab-box .tab.active::after{
        position: absolute;
        left: 50%;
        bottom: -.24rem;
        content: '';
        width: .6rem;
        height: 2px;
        margin-left: -.3rem;
        background: #4458ed;
    }
    .cont-box .tab-box .tab:last-child{
      display: flex;
      justify-content: flex-end;
      flex: 1;
      margin-right: 0;
    }
    .cont-box .tab-box .tab .icon{
      width: .6rem;
      height: .56rem;
    }
    .cont-box .tab-wrap .more{
      display: flex;
      align-items: center;
      margin-left: .3rem;
      padding: .5rem 0 .3rem;
    }
    .cont-box .tab-wrap .more .text{
      color: #878789;
      font-size: .34rem;
    }
    .cont-box .tab-wrap .more .arrow{
      width: .42rem;
      margin-left: .1rem;
    }
    .cont-box .item-box .item-li{
      padding: .48rem .28rem .24rem;
      margin-bottom: .24rem;
      background: #fff;
      box-sizing: border-box;
    }
    .cont-box .item-box .item-li .ul-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cont-box .item-box .item-li .li-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cont-box .item-box .item-li .li-head2{
      display: block;
    }
    .cont-box .item-box .item-li .title{
      color: #000;
      font-size: .42rem;
    }
    .cont-box .item-box .item-li .buy{
      display: inline-block;
      margin: 0 .15rem 0 .3rem;
      padding: .14rem .36rem;
      color: #27895b;
      font-size: .34rem;
      background: #daffee;
	    border-radius: 0.1rem;
    }
    .cont-box .item-box .item-li .bei{
      display: inline-block;
      margin: 0 .15rem 0 .3rem;
      padding: .14rem .2rem;
      color: #2d66cf;
      font-size: .34rem;
      background: #dfeaff;
	    border-radius: 0.1rem;
    }
   .cont-box .item-box .item-li .bei.sell{
      color: #cb4040;
      background: #ffe5e5;
    }
    .cont-box .item-box .item-li .lot{
      padding-left: .15rem;
      color: #878789;
      font-size: .34rem;
    }
    .cont-box .item-box .item-li .ul-box .li{
      margin-top: .34rem;
    }
    .cont-box .item-box .item-li .ul-box .li.li-lt .t2{
      display: flex;
      align-items: stretch;
      flex: 1
    }
    .cont-box .item-box .item-li .ul-box .li.li-lt .icon{
      width: .5rem;
      height: .3rem;
      margin: .1rem .4rem 0;
    }
    .cont-box .item-box .item-li .ul-box .li.li-lt .money{
      color: #000;
      font-size: .42rem;
    }
     .cont-box .item-box .item-li .ul-box .li.li-lt .text{
       padding-top: .32rem;
       color: #909090;
       font-size: .36rem;
     }
    .cont-box .item-box .item-li .ul-box .li3{
      margin-right: .2rem;
    }
    .cont-box .item-box .item-li .ul-box .li:last-child{
      margin-right: 0;
    }
    .cont-box .item-box .item-li .ul-box .t1{
      color: #000;
      font-size: .42rem;
    }
    .cont-box .item-box .item-li .ul-box .time{
      color: #909090;
    }
    /* .cont-box .item-box .item-li .ul-box .t1 .arrow{
      transform: rotate(270deg);
    } */
    .cont-box .item-box .item-li .ul-box .t2{
      margin-top: .34rem;
      color: #909090;
      font-size: .34rem;
    }
    .cont-box .item-box .item-li .ul-box .price{
      color: #00a94c;
    }
    .cont-box .item-box .item-li .time{
        color: #909090;
        font-size: .34rem;
    }
    .cont-box .item-box .item-li .btn-pc{
      padding: .2rem .5rem;
      color: #2d66cf;
      font-size: .34rem;
      word-break: keep-all;
      background: #f2f2f2;
	    border-radius: 0.36rem;
    }
    .cont-box .item-box .item-li .pc-price{
        color: #c62542;
        font-size: .48rem;
    }
    .kline-box{
        width: 100%;
        height: 11.5rem;
        background: #fff;
    }
    .theme .kline-box{
      background: #101928!important;
    }
    .btn-box{
        position: fixed;
        bottom: .3rem;
        z-index: 9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: .6rem .42rem .4rem;
        background: transparent!important;;
        box-sizing: border-box;
    }
    .btn-box .btn{
        flex: 1;
        /* height: 1.08rem; */
        padding: .3rem 0 .28rem;
        color: #fff;
        font-size: .4rem;
        border-radius: .15rem;
        text-align: center;
    }
    .btn-box .btn.btn-buy{
      margin-left: .8rem;
        background: #00c483;
    }
    .btn-box .btn.btn-sell{
        background: #d14b65;
    }
    .alert-wrap{
        position: fixed;
        z-index: 1000;
        width: 100%;
        height: 100%;
        padding: 0 .72rem;
        box-sizing: border-box;
    }
    .alert-wrap .alert-box{
        position: relative;
        top: 50%;
        width: 100%;
        padding: 0 .3rem;
        border-radius: 6px;
        background: #374c7c;
        transform: translateY(-50%);
        box-sizing: border-box;
    }
    .alert-wrap .alert-box .alert-head{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:.36rem 0 .3rem;
        border-bottom: 1px solid #838da5;
    }
    .alert-wrap .alert-box .alert-head .title{
        color: #fff;
        font-size: .42rem;
    }
    .alert-wrap .alert-box .alert-head .btn-close{
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap .alert-box .order-head{
        justify-content: center;
        border-bottom: none;
    }
    .alert-wrap .alert-box .alert-head .close{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .42rem;
        height: .42rem;
        margin-top: -.21rem;
    }
    .alert-wrap .alert-box .circle-box{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.52rem;
        height: 2.52rem;
        /* line-height: 84px; */
        margin: .24rem auto .42rem;
    }
    .alert-wrap .alert-box .circle-box .text{
        width: 80px;
        height: 80px;
        color: #4bb3e8;
        line-height: 80px;
        font-size: .42rem;
        text-align: center;
    }
    .alert-wrap .alert-box .circle{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 80px;
        height: 80px;
        transform: translate(-50%,-50%);
    }
    .alert-sec-circle {
        stroke-dashoffset: 0;
        stroke-dasharray: 720;
        transition: stroke-dashoffset 1s linear
    }
    .alert-wrap .alert-box .price-box{
        padding: 1.11rem 0 1.38rem;
        color: #00c488;
        text-align: center;
    }
    .alert-wrap .alert-box .price-box .num{
        font-size: .6rem;
    }
    .alert-wrap .item-box{
        padding: 0 20px;
    }
    .alert-wrap .item-box .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #c3c3c3;
        padding-bottom: .54rem;
    }
    .alert-wrap .item-box .item .t1{
        color: #fff;
    }
    .alert-wrap .item-box .item .t2{
        color: #fff;
    }
    .alert-wrap .alert-btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem 0 .54rem;
    }
    .alert-wrap .alert-btn-box .btn{
        height: 1.02rem;
        color: #fff;
        border-radius: .12rem;
        text-align: center;
    }
    .alert-wrap .alert-btn-box .btn.close{
        width: 106px;
        margin-right: .3rem;
        background: #367d99;
    }
    .alert-wrap .alert-btn-box .btn.order{
        flex: 1;
        background: #4bb3e8;
    }
    .alert-wrap .alert-tips{
        padding: .3rem 0;
        color: #c3c3c3;
    }
    .alert-wrap .time-wrap{
        width: 100%;
        height: 2.82rem;
        overflow: hidden;
    }
    .alert-wrap .time-wrap .time-box{
        width: 100%;
        height: 2.82rem;
        white-space: nowrap;
        overflow-x: auto;
    }
    .alert-wrap .time-wrap .time-item{
        position: relative;
        display: inline-block;
        min-width: 2.82rem;
        height: 2.7rem;
        margin-right: .27rem;
        font-size: .39rem;
        border: 2px solid transparent;
        border-radius: .18rem;
        background: #30385d;
        text-align: center;
    }
    .alert-wrap .time-wrap .time-item.active{
        border: 2px solid #4bb3e8;
    }
    .alert-wrap .time-wrap .time-item .icon{
        position: absolute;
        right: -2px;
        top: -2px;
        width: .84rem;
        height: .78rem;
    }
    .alert-wrap .time-wrap .time-item .t1{
        padding: .36rem .12rem .27rem;
        color: #8e8e8e;
    }
    .alert-wrap .time-wrap .time-item .time{
        color: #4bb3e8;
    }
    .alert-wrap .time-wrap .time-item .num{
        font-size: .48rem;
    }
    .alert-wrap .time-wrap .time-item .t2{
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: .15rem 0;
        color: #db4949;
        border-radius: 0 0 .18rem .18rem;
        background: rgba(0,0,0,.5);
    }
    .alert-wrap .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.08rem;
        border-radius: .18rem;
        background: #30385d;
    }
    .alert-wrap .input-box .input{
        flex: 1;
        height: 1.08rem;
        padding: 0 .27rem;
        color: #fff;
    }
    .alert-wrap .input-box .text{
        color: #c3c3c3;
        padding-right: .3rem;
    }
    .alert-wrap .ky-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .36rem 0;
        color: #c3c3c3;
        border-bottom: 1px solid #838da5;
    }
    .alert-wrap .ky-box .text{
        display: flex;
        align-items: center;
    }
    .alert-wrap .ky-box .text .money{
        padding: 0 .3rem;
    }
    .alert-wrap .ky-box .text .icon{
        width: .6rem;
        height: .6rem;
    }
    .alert-wrap .trade-wrap{
        padding: .24rem 0 .6rem;
    }
    .alert-wrap .trade-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap .trade-box .text{
        width: 33.33%;
        color: #c3c3c3;
    }
    .alert-wrap .trade-item{
        padding-top: .42rem;
    }
    .alert-wrap .trade-item .t1{
        color: #fff;
    }
    .alert-wrap .trade-item .t2{
        color: #00c483;
    }
    .alert-wrap .trade-item .t2.active{
        color: #d14b65;
    }
    .alert-wrap .trade-item .t3{
        color: #4bb3e8;
    }
    /* 平仓 */
    .alert-pc-box{
        position: fixed;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        padding: .62rem .62rem .8rem;
        border-radius: .4rem .4rem 0 0;
        background: #fff;
        box-sizing: border-box;
    }
    .alert-pc-box .title{
        position: relative;
        color: #000;
        font-size: .56rem;
        text-align: center;
    }
    .alert-pc-box .close{
        position: absolute;
        top: 50%;
        right: 0;
        width: .74rem;
        transform: translateY(-50%);
    }
    .alert-pc-box .alert-item-box{
        margin-top: .8rem;
        padding: .5rem .42rem .58rem;
        border-radius: 0.3rem;
	    border: 1px solid #d9d9d9
    }
    .alert-pc-box .alert-item-box .title{
        color: #000;
        font-size: .42rem;
    }
    .alert-pc-box .alert-item-box .buy{
        display: inline-block;
        margin: 0 .12rem 0 .2rem;
        padding: .14rem .32rem;
        color: #c62542;
        font-size: .34rem;
        background: #ffe4e9;
        border-radius: .1rem;
    }
    .alert-pc-box .alert-item-box .bei{
        display: inline-block;
        margin: 0 .12rem 0 0;
        padding: .14rem .32rem;
        color: #2d66cf;
        font-size: .34rem;
        background: #dfeaff;
        border-radius: .1rem;
    }
    .alert-pc-box .alert-item-box .lot{
        color: #878789;
        font-size: .34rem;
    }
    .alert-pc-box .alert-item-box .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .78rem;
    }
    .alert-pc-box .alert-item-box .t1{
        color: #000;
        font-size: .4rem;
    }
    .alert-pc-box .alert-item-box .t1.price{
        color: #00a94c;
    }
    .alert-pc-box .alert-item-box .t2{
        padding-top: .34rem;
        color: #909090;
        font-size: .34rem;
    }
    .alert-pc-box .tips{
        padding: .4rem 0 .32rem;
        color: #686868;
        font-size: .34rem;
    }
    .alert-pc-box .num-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem .56rem;
        background: #f3f5fa;
	    border-radius: 0.3rem;
    }
    .alert-pc-box .num-box .icon{
        width: .5rem;
    }
    .alert-pc-box .num-box .t1{
      display: flex;
      align-items: center;
        color: #000;
        font-size: .48rem;
        text-align: center;
    }
    .alert-pc-box .num-box .t1 .number{
      width: 2.2rem;
      text-align: center;
    }
    .alert-pc-box .num-box .t2{
        color: #686868;
        font-size: .3rem;
        text-align: center;
    }
    .alert-pc-box .btn-sure{
        margin-top: .7rem;
    }
    .charts{
      width: 100%;
      height: 420px;
    }
    .mn-box{
      position: fixed;
      top: 1.6rem;
      width: 100%;
      height: 0.8rem;
      color: #fff;
      font-size: .42rem;
      line-height: .8rem;
      background: #d14b65;
      text-align: center;
    }
</style>
<style>
  .charts-tooltip-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 5px 0;
    }
    .scroll-box.mn{
      top: 3.82rem;
    }
    .scroll-box.mn .kline-head{
      top: 2.4rem
    }
</style>



// WEBPACK FOOTER //
// src/pages/preciousMetal.vue